import {HttpClient} from '@angular/common/http';
import {Component} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {HubApiService} from '../../services/hub-api.service';

interface SwissQrResult {
  success: boolean;
  dataUri?: string;
  errors?: Array<{ path: string; message: string }>;
}

@Component({
  selector: 'hub-swiss-qr-code',
  imports: [FormsModule],
  templateUrl: './swiss-qr-code.component.html',
  styleUrl: './swiss-qr-code.component.css'
})
export class SwissQrCodeComponent {
  fields = ['creditor-name', 'creditor-addressLine1', 'creditor-addressLine2', 'creditor-country', 'creditorInformation-iban'];
  values: Record<string, string> = {'creditor-country': 'CH'};
  errors: Record<string, string> = {};
  dataUri = '';
  loading = false;

  constructor(private http: HttpClient, private hubApi: HubApiService) {
  }

  generate(): void {
    this.loading = true;
    this.errors = {};
    this.dataUri = '';
    const formData = new FormData();
    for (const field of this.fields) {
      formData.append(field, this.values[field] || '');
    }
    this.http.post<SwissQrResult>('https://api.goodvantage.net/qr.php', formData).subscribe({
      next: (result) => {
        if (result.success && result.dataUri) {
          this.dataUri = result.dataUri;
        } else {
          for (const error of result.errors || []) {
            this.errors[error.path.replace('.', '-')] = error.message;
          }
        }
        this.loading = false;
      },
      error: () => {
        this.errors['_global'] = this.t('HubQrCodeGenerateFailedMessage');
        this.loading = false;
      }
    });
  }

  label(field: string): string {
    return this.hubApi.translate(`SwissQrFormLabel${field}`) || field;
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }
}
